import { Route, Routes } from "react-router-dom";

import EprLinks from "./components/EprLinks";
import Interrupt from "./components/Interrupt";
import LoadTest from "./components/LoadTest";
import Login from "./components/Login";
import Main from "./components/Main";
import NotFound from "./components/NotFound";
import PrivateRoute from "./components/PrivateRoute";

const App = () => {
    return (
        <Routes>
            <Route path="/" exact element={<PrivateRoute />}>
                <Route path="/" exact element={<Main />} />
            </Route>
            <Route path="/home" exact element={<PrivateRoute />}>
                <Route path="/home" exact element={<Main />} />
            </Route>
            <Route path="/epr-archive" exact element={<NotFound />} />
            <Route path="/epr-archive/:studentNumber" exact element={<PrivateRoute />}>
                <Route path="/epr-archive/:studentNumber" exact element={<EprLinks />} />
            </Route>
            <Route path="/login-welcome" element={<Interrupt />} />
            <Route path="/notFound" element={<NotFound />} />
            <Route default element={<NotFound />} />
            {/* Development ONLY */}
            {process.env.NODE_ENV !== "production" && (
                <>
                    <Route path="/backdoor" exact element={<Login />} />
                    <Route path="/loadtest" exact element={<NotFound />} />
                    <Route path="/loadtest/:userName" element={<PrivateRoute />}>
                        <Route path="/loadtest/:userName" element={<LoadTest />} />
                    </Route>
                </>
            )}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default App;
